import {contentSections, safeImageUrl} from './cmsMedia';
export const ORIGINAL_HERO_VIDEO = '/media/flytteguide.mp4';
export const ORIGINAL_HERO_POSTER = '/media/flytteguide-poster-original.webp';
export const HERO_MEDIA_TYPE = 'heroMedia';
export function rawHomeHeroMedia(content) {
  const section = contentSections(content || {}).find(item => item?.type === HERO_MEDIA_TYPE);
  return section?.data || section || {};
}
export function safeVideoUrl(value) {
  const url = safeImageUrl(value);
  if (!url) return null;
  try { return /\.(mp4|webm|ogv)$/i.test(new URL(url, 'https://media.invalid').pathname) ? url : null; } catch { return null; }
}
export function homeHeroMedia(content) {
  const raw = rawHomeHeroMedia(content);
  const position = /^(?:100|[1-9]?\d)% (?:100|[1-9]?\d)%$/.test(raw.position || '') ? raw.position : undefined;
  return {desktop: safeVideoUrl(raw.desktopVideoUrl) || ORIGINAL_HERO_VIDEO,
    mobile: safeVideoUrl(raw.mobileVideoUrl), poster: safeImageUrl(raw.posterUrl) || ORIGINAL_HERO_POSTER, position};
}
export function updateHomeHeroMedia(content, field, value) {
  if (!['desktopVideoUrl', 'mobileVideoUrl', 'posterUrl', 'position'].includes(field)) return content;
  const sections = contentSections(content);
  const index = sections.findIndex(item => item?.type === HERO_MEDIA_TYPE);
  if (index < 0) return {...content, sections: [...sections, {id: 'homepage-hero-media', type: HERO_MEDIA_TYPE, [field]: value}]};
  return {...content, sections: sections.map((item, i) => i !== index ? item : item.data ? {...item, data: {...item.data, [field]: value}} : {...item, [field]: value})};
}
